<template>
  <div class="article">
    <bread-crumb></bread-crumb>
    <div class="wrap">
      <AuditInfoBaike
        actionType="13"
        :contentId="form.contentId"
        :contentName="form.contentName"
      ></AuditInfoBaike>
      <div class="c-title-wrap">
        <p class="c-title">基本内容</p>
      </div>
      <!--别名-->
      <contentAlias-Names :aliasName.sync="form.contentAliasNames" />
      <!-- 药品分类 -->
      <category-drugs
        ref="categoryDrugsRef"
        :functionIds="{
          queryDrugCategoryWithRel: 'health_cmp_biz_queryDrugCategoryWithRel',
        }"
        @checkCateGoryLabel="checkCateGoryLabel"
      />
      <!-- 处方药 -->
      <prescription-drugs :prescriptionDrug.sync="prescriptionDrug" />
      <!--关联药品-->
      <select-encyclopedia
        :data="form.contentDrugs"
        @changeEncyclopediaLabels="changeEncyclopediaLabels"
        :is-show-encyclopedia="isShowEncyclopedia"
        :functionIds="{
          queryEncyclopedia: 'health_cmp_biz_manPageDrugInfoByParam',
        }"
      ></select-encyclopedia>
      <!--关联疾病-->
      <encyclopedia-label
        :data="form.contentDiseases"
        @changeDiseaseLabels="changeDiseaseLabels"
        :is-show-disease="isShowDisease"
        :functionIds="{ queryContents: 'health_cmp_pageDiseaseInfoByParam' }"
      ></encyclopedia-label>
      <!--基本信息-->
      <div
        class="content-item flex"
        style="position: relative"
        v-for="(item, index) in paragraphList"
        :key="index"
      >
        <p class="content-item-label">
          <span class="red">*</span>{{ item.desc }}
        </p>
        <c-editor
          :content="item.content || ''"
          :index="index"
          @editorReady="editorReady"
          :ref="'editor' + index"
          @blurEditorEvent="blurEditorEvent"
        ></c-editor>
      </div>
      <!--标签-->
      <content-label
        ref="contentLabelref"
        :functionIds="{
          listTenantContentLabels: 'health_cmp_biz_pageAuditLabels',
        }"
        @checkArticleLabel="checkArticleLabel"
      />
      <!-- <div class="writeDoc content-item flex align-items-center">
        <div class="content-item-label">
          常见药品
        </div>
        <el-radio v-model="commonDrugs" label="1">是</el-radio>
        <el-radio v-model="commonDrugs" label="2">否</el-radio>
      </div> -->
      <!--编写医生-->
      <write-doctor
        :writeDoctor.sync="writeDoctor"
        :writeOptions="writeOptions"
        :write_doctor_loading="write_doctor_loading"
        @write_remoteMethod="write_remoteMethod"
        @writeChange="writeChange"
        :isFlag="true"
        :flag="false"
      ></write-doctor>
      <!--编审医生-->
      <write-doctor
        :writeDoctor.sync="doctor"
        :writeOptions="doctorOptions"
        :write_doctor_loading="search_doctor_loading"
        @write_remoteMethod="doctor_remoteMethod"
        @writeChange="writeChange"
        :isFlag="true"
        :Pharmacist="1"
      ></write-doctor>
      <!--关键词-->
      <keywords :keyWordsShow="keyWordsShow" ref="keywordsref"></keywords>
    </div>
    <div class="finish-buttons">
      <el-button
        type="primary"
        v-if="auditInfoShow == 2"
        @click="manOrUpdateDiseaseInfo(2, 'through')"
      >
        <span>通过</span>
      </el-button>
      <el-button v-if="auditInfoShow == 2" @click="rejectClick">
        <span>驳回</span>
      </el-button>
      <el-button
        v-if="auditInfoShow == 2 ? false : auditInfoShow == 3 ? false : true"
        @click="manOrUpdateDiseaseInfo(1, 'save')"
      >
        <span>保存</span>
      </el-button>
      <el-button
        type="primary"
        v-if="auditInfoShow !== 2"
        @click="manOrUpdateDiseaseInfo(2, 'manSubmit')"
      >
        <span>提交</span>
      </el-button>
      <el-button @click="manOrUpdateDiseaseInfo(0, 'manPreview')">
        <span>预览</span>
      </el-button>
    </div>
    <preview-modal
      :mUrl.sync="mUrl"
      :dialogPreVisible.sync="dialogPreVisible"
      :qrCode="qrCode"
    ></preview-modal>
    <reject-modal
      :rejectForm.sync="rejectForm"
      @rejectClickHandler="rejectClickHandler"
    ></reject-modal>
  </div>
</template>

<script>
import BreadCrumb from "@/components/breadCrumb";
import EncyclopediaName from "@/components/input/EncyclopediaName";
import contentAliasNames from "@/components/input/contentAliasNames";
import SelectEncyclopedia from "@/components/tag/SelectEncyclopedia";
import CEditor from "@/components/cEditor";
import WriteDoctor from "@/components/select/WriteDoctor";
import Keywords from "@/components/input/Keywords";
import ContentLabel from "@/components/tag/ContentLabel";
import CategoryDrugs from "@/components/radio/CategoryDrugs";
import PrescriptionDrugs from "@/components/radio/PrescriptionDrugs";
import { request } from "@/utils/axios";
import EncyclopediaLabel from "@/components/tag/EncyclopediaLabel";
import utils from "@/utils";
import RejectModal from "@/components/pop/RejectModal";
import PreviewModal from "@/components/pop/PreviewModal";
import { getQRCode } from "@/utils/tools";
import AuditInfoBaike from "@/components/customize/AuditInfoBaike";

const baseUrl = process.env.VUE_APP_BASEURL;

export default {
  name: "encyclopediaEdit",
  components: {
    AuditInfoBaike,
    PreviewModal,
    RejectModal,
    EncyclopediaLabel,
    Keywords,
    WriteDoctor,
    CEditor,
    SelectEncyclopedia,
    PrescriptionDrugs,
    contentAliasNames,
    BreadCrumb,
    EncyclopediaName,
    ContentLabel,
    CategoryDrugs,
  },
  data() {
    return {
      form: {
        tenantId: Number(this.$commonJs.getTenantId()), // 租户id
        contentName: "", // 药品名称
        aliasName: "", // 别名  加一个contentaliasname
        contentAliasNames: [],
        contentDiseases: [], //绑定疾病id
        keywordInfos: [], // 内容关键词
        doctorInfos: [], // 关联的医生
        contentDrugs: [], // 药品
        contentParagraphs: [], // 段落
        contentAttributes: [], // 常见药品
        contentId: undefined,
        contentLabels: [], // 标签信息
        drugCategories: [], // 药品分类
      },
      prescriptionDrug: 0, // 是否为处方药
      rejectForm: {
        rejectlineDialog: false,
        rejectReasons: "",
        isShowBtn: [true, true], //弹窗是否能显示按钮
        ordinaryBtnText: ["取消", "确认"],
      },
      // 编写医生
      write_doctor_loading: false,
      writeOptions: [],
      writeDoctor: "",
      // 编审医生
      search_doctor_loading: false,
      doctorOptions: [],
      doctor: "",
      isShowDisease: false,
      dialogPreVisible: false,
      commonDrugs: "2",
      isShowEncyclopedia: false,
      paragraphList: [],
      editorList: {},
      keyWordsShow: 1,
      auditInfoShow: "",
      mUrl: "",
      baseUrl,
    };
  },
  async created() {
    if (this.$route.query.id) {
      this.form.contentId = this.$route.query.id;
    }
    await this.getDiseaseInfoDraftDetail();
  },
  async mounted() {
    this.getContentParagraphDictionary(); // 获取段落信息
    await this.$refs.contentLabelref.listTenantContentLabels();

    this.$refs.categoryDrugsRef.queryDrugCategoryWithRel(this.form.contentId);
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.cancel, false);
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.cancel, false);
    // 移除段落缓存
    sessionStorage.removeItem("cache_articles");
  },
  methods: {
    cancel: function () {
      this.$router.push(`/wikiManage/drug`);
      this.hopStorage();
    },
    editorReady(data) {
      this.editorList["editor" + data.index] = data.editor;
      this.restoreContentParagraphs(data);
    },
    // 恢复段落内容
    restoreContentParagraphs({ editor, index }) {
      var article = this.$commonJs.getArticleDataFromCache(this.form.contentId);
      if (!article) {
        return;
      }
      this.$set(
        this.paragraphList[index],
        "content",
        article.contentParagraphs[index].paragraphContent
      );
    },
    blurEditorEvent(editor, index) {
      this.paragraphList[index].content = editor.getContent() || "";
      // var tipDom = $(
      //   '<div class="successfully" style="position: absolute; top: 0; right: 15px;color: green;">保存成功</div>'
      // );
      // let ParentElement = $(editor.editorContainer).find(".tox-toolbar__group").eq(0)
      // let subelement = ParentElement.find(".successfully")
      // // 只创建一次
      // if (subelement.length == 0) {
      //   $(editor.editorContainer).find(".tox-toolbar__group").eq(0).append(tipDom);
      // }
      // clearTimeout(this.tipTimeout);
      // this.tipTimeout = setTimeout(function () {
      //   var DeleteElement = $(".tox-toolbar__group .successfully:eq(0)");
      //   if (DeleteElement) {
      //     DeleteElement.remove()
      //   }
      // }, 500);

      var cacheArticle = this.$commonJs.getArticleDataFromCache(
        this.form.contentId
      );
      if (cacheArticle) {
        this.form.contentParagraphs = cacheArticle.contentParagraphs;
      } else {
        // 如果不存在，则新增一篇文章
        this.paragraphList.forEach((item) => {
          this.form.contentParagraphs.push({
            paragraphCode: item.code,
            paragraphName: item.desc,
            paragraphType: item.type,
            paragraphContent: item.content || "",
          });
        });
      }
      this.form.contentParagraphs[index].paragraphContent =
        editor.getContent() || "";
      this.$commonJs.setCacheArticleData(this.$commonJs.deepClone(this.form));
    },

    // 获取药品信息
    changeEncyclopediaLabels(data) {
      this.form.contentDrugs = data;
    },
    //获取疾病信息
    changeDiseaseLabels(data) {
      // 关联疾病
      this.form.contentRelations = data;
    },
    //获取段落信息
    getContentParagraphDictionary() {
      request("health_cmp_getContentParagraphDictionary", {
        type: 7,
      })
        .then((res) => {
          this.paragraphList = res || [];
        })
        .catch((err) => {});
    },
    //选中文章标签
    checkArticleLabel(label) {
      this.$set(label, "isChecked", !label.isChecked);

      let arr = this.form.contentLabels || [];
      //判断是否存在当前项，如果存在则取消选中并从数据中删除
      if (!label.isChecked) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id == label.id) {
            this.form.contentLabels.splice(i, 1);
            return false;
          }
        }
      }
      let obj = {
        labelGroupId: label.labelGroupId,
        id: label.id,
        name: label.name,
      };
      this.form.contentLabels.push(obj);
    },
    // 药品分类
    checkCateGoryLabel(categoryDrugs, index) {
      //判断是否存在当前项，如果存在则取消选中并从数据中删除
      this.form.drugCategories = [];
      let obj = {
        sort: categoryDrugs[index].sort,
        id: categoryDrugs[index].id,
        name: categoryDrugs[index].name,
      };
      this.form.drugCategories.push(obj);
    },
    // 获取文章详情
    async getDiseaseInfoDraftDetail() {
      await request("health_cmp_queryContentDraftById", {
        contentId: this.$route.query.id,
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        this.displayInfo(res);
      });
    },
    // 回显标签
    showSelectedLabels() {
      if (
        !this.$refs.contentLabelref.contentLabels ||
        !this.$refs.contentLabelref.contentLabels.length ||
        !this.form.contentLabels ||
        !this.form.contentLabels.length
      ) {
        return;
      }
      for (
        var i = 0;
        i < this.$refs.contentLabelref.contentLabels.length;
        i++
      ) {
        var group = this.$refs.contentLabelref.contentLabels[i];
        for (var j = 0; j < group.contentLabels.length; j++) {
          var label1 = group.contentLabels[j];
          for (var k = 0; k < this.form.contentLabels.length; k++) {
            var seletedLabel = this.form.contentLabels[k];
            if (label1.id == seletedLabel.id) {
              this.$set(label1, "isChecked", true);
              break;
            }
          }
        }
      }
    },
    // 反显信息
    displayInfo(res) {
      if (res.auditInfo) {
        this.auditInfoShow = res.auditInfo.auditStatus;
      }
      // 回显上次保存的标签
      this.form.contentLabels = res.contentLabels || [];
      this.showSelectedLabels();
      //反显药品名称
      if (res.contentName) {
        this.form.contentName = res.contentName;
      }
      if (res.contentDrugs) {
        this.form.contentDrugs = res.contentDrugs;
      }
      //反显别名
      if (!res.contentAliasNames) {
        this.form.contentAliasNames = [];
      } else {
        this.form.contentAliasNames = res.contentAliasNames;
      }

      // 反显药品分类
      this.form.drugCategories = res.drugCategories || [];
      //反显关联疾病
      this.form.contentDiseases = res.contentDiseases || [];
      //反显段落
      this.form.contentParagraphs = res.contentParagraphs || [];
      //反显段落
      this.form.contentParagraphs = res.contentParagraphs || [];
      var cache_article = this.$commonJs.getArticleDataFromCache(res.contentId);
      if (!cache_article) {
        var isFirstAdd = this.paragraphList.length == 0;
        res.contentParagraphs &&
          res.contentParagraphs.map((item, index) => {
            if (isFirstAdd) {
              this.paragraphList.push({
                code: item.paragraphCode,
                desc: item.paragraphName,
                type: item.paragraphType,
                content: item.paragraphContent || "",
              });
            } else {
              for (var i = 0; i < this.paragraphList.length; i++) {
                if (this.paragraphList[i].code == item.paragraphCode) {
                  this.paragraphList[i].content == item.paragraphContent || "";
                  break;
                }
              }
            }
            try {
              var isEditorInited = setInterval(() => {
                var edd = this.editorList["editor" + index];
                if (edd) {
                  clearInterval(isEditorInited);
                  edd.setContent(item.paragraphContent || "");
                }
              }, 100);
            } catch (error) {
              console.log(error);
            }
          });
      }
      this.writeOptions = [];
      this.doctorOptions = [];
      if (res.doctorInfos) {
        res.doctorInfos.map((item) => {
          if (item.roleType == 1) {
            this.writeOptions.push(item);
            this.writeDoctor = item.docId;
          }
        });
      }
      // 编审 编写医生
      if (res.doctorInfos) {
        res.doctorInfos.map((item) => {
          if (item.roleType == 2) {
            this.doctorOptions.push(item);
            this.doctor = item.docId;
          }
        });
      }
      if (res.contentAttributes) {
        // 反显处方药 单选 type为9
        this.prescriptionDrug =
          this.filterContentAttrbutes(res.contentAttributes, 9).code || 0;
        // 反显常见药品 单选 type为8
        this.commonDrugs =
          this.filterContentAttrbutes(res.contentAttributes, 8).code || 0;
      }
      //反显关键字
      this.$refs.keywordsref.keywordInfos = [];
      res.keywordInfos &&
        res.keywordInfos.map((item, index) => {
          this.$refs.keywordsref.keywordInfos.push(item.keyword);
        });
    },
    filterContentAttrbutes(arr, type) {
      const filterArr = arr.filter((item) => item.type == type);
      return filterArr.length > 0 ? filterArr[0] : {};
    },
    initFormBeforeAddOrUpdate(val, opt_type) {
      this.form.contentName = this.form.contentName.trim();
      this.form.contentParagraphs = [];
      this.paragraphList.map((item, index) => {
        this.form.contentParagraphs.push({
          paragraphCode: item.code,
          paragraphName: item.desc,
          paragraphType: item.type,
          paragraphContent:
            this.editorList["editor" + index].getContent() || "",
        });
      });
      // 处方药
      this.form.contentAttributes = [];
      this.form.contentAttributes.push({
        type: 9,
        code: Number(this.prescriptionDrug),
      });
      if (this.$refs.keywordsref.keywordInfos.length) {
        let arr = [];
        this.$refs.keywordsref.keywordInfos.map((item) => {
          arr.push({
            keyword: item,
            keywordType: "1",
          });
        });
        this.form.keywordInfos = arr;
      } else {
        this.form.keywordInfos = [];
      }
      this.form.doctorInfos = [];
      // 编写医生
      this.writeOptions.map((item) => {
        if (this.writeDoctor == item.docId) {
          item.roleType = 1;
          this.form.doctorInfos.push(item);
        }
      });
      // 编审医生
      this.doctorOptions.map((item) => {
        if (this.doctor == item.docId) {
          item.roleType = 2;
          this.form.doctorInfos.push(item);
        }
      });
      // 常见药品处理
      this.form.contentAttributes.push({
        type: 8,
        code: Number(this.commonDrugs),
      });
    },
    // 校验
    checkBeforeAddOrUpdate(val, opt_type) {
      if (!this.form.contentName || this.form.contentName.trim() == "") {
        this.$message.error("药品名称不能为空");
        return false;
      }
      if (!this.form.drugCategories || this.form.drugCategories.length == 0) {
        this.$message.error("药品分类不能为空");
        return false;
      }
      if (val == 1 || val == 0) return true; // 若为保存、预览只校验名称
      let isParagraphsPass = true;
      let paragraphsText = [];
      isParagraphsPass = this.form.contentParagraphs.some((item) => {
        paragraphsText.push(item.paragraphName);
        return item.paragraphContent != "";
      });
      if (!isParagraphsPass) {
        this.$message.error(paragraphsText.join(",") + "至少填写一项");
        return false;
      }
      return true;
    },
    // 审核-提交-保存
    manOrUpdateDiseaseInfo(val, type) {
      this.initFormBeforeAddOrUpdate(val, type);
      if (!this.checkBeforeAddOrUpdate(val, type)) return;
      if (!utils.copyPictureCheck(this.form.contentParagraphs, this)) return;
      let params = this.$commonJs.deepClone(this.form);
      params.contentType = 13;
      params.contentId = this.$route.query.id || "";
      request("health_cmp_biz_manUpdateDrugBaike", params).then((res) => {
        let contentIds = {
          contentId: this.$route.query.id,
          tenantId: this.$commonJs.getTenantId(),
        };
        if (type == "manPreview") {
          this.articlePreview(contentIds);
        }
        if (type == "save") {
          this.$message.success("保存成功");
        } else if (type == "through") {
          params.auditInfo = { auditStatus: 3 };
          // 审核
          request("health_cmp_manPassContent", contentIds)
            .then((res) => {
              if (res.code === "0000" && !res.data) {
                this.$message.error("操作失败");
                return;
              }
              this.$message.success("审核通过");
              this.$router.push(`/wikiManage/drug`);
              this.hopStorage();
            })
            .catch((err) => {
              this.$message.error(err.msg || "审核失败");
            });
        } else if (type == "manSubmit") {
          params.auditInfo = { auditStatus: 2 };
          request("health_cmp_manPublishContent", contentIds)
            .then((res) => {
              if (res) {
                this.$router.push(`/wikiManage/drug`);
                this.hopStorage();
              }
              this.$message.success("提交成功");
            })
            .catch((err) => {
              this.$message.error(err.msg + "发布失败");
            });
        }
      });
    },
    // 预览
    articlePreview(val) {
      this.dialogPreVisible = true;
      this.previewDialog = true;
      this.jumpUrl("/drugs", "/preview/", val.contentId);
    },
    jumpUrl(url, type, urlId) {
      let urlAddress = "//beta-api.m.jd.com";
      let previewUrl1 = "https://cont-yf.healthjd.com/wiki"; // 疾病症状预发地址
      let diseaseOnline = "https://cont.healthjd.com/wiki"; // 线上疾病
      let newUrl;
      if (this.baseUrl == urlAddress) {
        newUrl = previewUrl1 + url + type + urlId;
      } else {
        newUrl = diseaseOnline + url + type + urlId;
      }
      this.mUrl = newUrl;
      getQRCode(newUrl, (url) => {
        this.qrCode = url;
        this.dialogPreVisible = true;
      });
    },
    // 编审医生
    doctor_remoteMethod(query) {
      this.doctorList(query, "doctorOptions", "search_doctor_loading");
    },
    // 编写医生
    write_remoteMethod(query) {
      this.doctorList(query, "writeOptions", "write_doctor_loading");
    },
    writeChange() {
      if (this.writeDoctor == "") {
        this.writeOptions = [];
      }
      if (this.doctor == "") {
        this.doctorOptions = [];
      }
    },
    doctorList(query, str, loadingStr) {
      if (query !== "") {
        this[loadingStr] = true;
        request("health_cmp_listByDoctorName", {
          tenantId: this.$commonJs.getTenantId(),
          doctorName: query,
        })
          .then((res) => {
            this[str] = res;
            this[loadingStr] = false;
          })
          .catch((err) => {
            this[str] = [];
            this[loadingStr] = false;
          });
      } else {
        this[str] = [];
      }
    },
    //审核--驳回
    rejectClick() {
      this.rejectForm.rejectlineDialog = true;
    },
    rejectClickHandler(arg) {
      if (arg === "two") {
        if (this.rejectForm.rejectReasons === "") {
          this.$message.error("驳回理由不能为空");
        } else {
          //contentAuditStatus:1草稿、2待审核、3审核通过、4驳回 9撤销投稿
          request("health_cmp_manRejectContent", {
            contentId: this.$route.query.id,
            tenantId: this.$commonJs.getTenantId(),
            remark: this.rejectForm.rejectReasons,
          })
            .then((res) => {
              this.rejectForm.rejectlineDialog = false;
              this.rejectForm.rejectReasons = ""; //置空驳回原因
              this.$message.success("驳回成功");
              this.hopStorage();
              this.$router.push(`/wikiManage/drug`);
            })
            .catch((err) => {
              this.$message.error(err.msg || "驳回失败");
            });
        }
      } else {
        this.rejectForm.rejectlineDialog = false;
      }
    },
    hopStorage() {
      // 跳转列表页存储状态
      sessionStorage.setItem("encyclopedia", 1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/article_common.scss";

.article {
  @include article_common;

  .item-video-wrap {
    border: 1px solid #c0c4cc;
  }

  :deep(.el-form-item) {
    margin-bottom: 22px;
  }
  :deep(.el-textarea__inner) {
    resize: none;
  }
  :deep(.el-dialog__body) {
    padding: 30px 26px 0px 26px !important;
  }

  :deep(.el-dialog__body) {
    padding: 30px 26px 0px 26px !important;
  }

  .el-button {
    line-height: 10px;
  }

  .article_tit {
    .el-input__suffix {
      left: 100% !important;
      right: auto !important;
    }
  }
}

.finish-buttons {
  position: fixed;
  text-align: center;
  width: 86%;
  background-color: #ffffff;
  bottom: 0;
  z-index: 9;
}

.article .wrap .writeDoc .el-input {
  width: 645px !important;
}
</style>
